import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Text } from "react-native-paper";
import { themeRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export const LeaderboardYouBadge = () => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box
			paddingHorizontal={6}
			paddingVertical={2}
			borderRadius={theme.roundness * themeRoundnessMultiplier}
			backgroundColor={theme.colors.secondary}
		>
			<Text
				variant="labelSmall"
				style={[styles.label, { color: theme.colors.onPrimary }]}
			>
				{t("leaderboard.youBadge")}
			</Text>
		</Box>
	);
};

const styles = StyleSheet.create({
	label: {
		fontWeight: "600",
	},
});
